import { DEFAULT_GOOGLE_DRIVE_REQUEST_DATA } from "constants/widgetBuilder";
import { WidgetSectionTypes } from "models/DynamicWidget";
import {
	GoogleRequestDataTypes,
	SelectedFileTypes,
	TikTokUserTypes,
	UploadRequestPayloadTypes,
} from "models/Widget";
import React from "react";

export type DynamicWidgetContextTypes = {
	currentSections: WidgetSectionTypes[];
	navigatePage: (action: string) => void;
	localFileList: SelectedFileTypes[];
	setLocalFileList: (files: SelectedFileTypes[]) => void;
	widgetDetails: any;
	pagePosition: {
		isFirst: boolean;
		isLast: boolean;
	};
	clearForm: () => void;
	setFieldsValue: (values: any) => void;
	formValues: UploadRequestPayloadTypes | null;
	setFormValues: (values: UploadRequestPayloadTypes | null) => void;
	handleSubmitButton: () => void;
	googleRequestData: GoogleRequestDataTypes;
	setGoogleRequestData: (values: GoogleRequestDataTypes) => void;
	setActiveUploadType: (type: string) => void;
	activeUploadType: string;
	modalType: string;
	setModalType: (type: string) => void;
	setTikTokUser: (user: TikTokUserTypes) => void;
	tikTokUser?: TikTokUserTypes;
	selectedSocialVideoList: SelectedFileTypes[];
	setSelectedSocialVideoList: (list: SelectedFileTypes[]) => void;
	isFileListEmpty: boolean;
};

const values: DynamicWidgetContextTypes = {
	currentSections: [],
	navigatePage: () => {},
	localFileList: [],
	setLocalFileList: () => {},
	widgetDetails: {},
	pagePosition: {
		isFirst: true,
		isLast: false,
	},
	clearForm: () => {},
	setFieldsValue: () => {},
	formValues: null,
	setFormValues: () => {},
	handleSubmitButton: () => {},
	setGoogleRequestData: () => {},
	setActiveUploadType: () => {},
	googleRequestData: DEFAULT_GOOGLE_DRIVE_REQUEST_DATA,
	activeUploadType: "",
	modalType: "",
	setModalType: () => {},
	setTikTokUser: () => {},
	selectedSocialVideoList: [],
	setSelectedSocialVideoList: () => {},
	isFileListEmpty: true,
};

const DynamicWidgetContext = React.createContext(values);
export default DynamicWidgetContext;
